import AgTechFieldList from '@agtech/web/components/Fields/AgTechFieldList'
import AgTechHeaderDetail from '@agtech/web/components/Headers/AgTechHeaderDetail'
import AgTechThinTabbedPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechThinTabPage'
import { SaleContactDetailsProvider } from '@sales/data/operation/contacts/SaleContactDataQueries'
import React from 'react'
import SaleContactDetailPopUpCreditsTab from './tabs/SaleContactDetailPopUpCreditsTab'
import SaleContactDetailDialog from '../../dialogs/SaleContactDetailDialog'
import { getContactFullName } from '@agtech/data/contacts/ContactData'
import ContactPopUpNotesTab from '@agtech/web/integrations/contacts/popups/tabs/ContactPopUpNotesTab'

export type SaleContactDetailPopUpProps = {
    contactId: number
}

const SaleContactDetailPopUp = (props: SaleContactDetailPopUpProps) => {
    return (
        <div className='row-based container' style={{ height: 320, width: 480 }}>
            <SaleContactDetailsProvider contactId={props.contactId} >
                {(contactDetails) => {
                    const contact = contactDetails.contact;

                    return (
                        <div className='stretched row-based flex'>
                            <AgTechHeaderDetail
                                header={getContactFullName(contact)}
                                settings={{
                                    classes: 'px-3 pt-2 pb-5',
                                    header: {
                                        classes: '!text-plus'
                                    }
                                }}
                            />
                            <div className='flexed scrollable container'>
                                <AgTechThinTabbedPage
                                    key={contactDetails.contact.id}
                                    header={{
                                        classes: 'px-3'
                                    }}
                                    body={{
                                        classes: 'bg-light-gray'
                                    }}
                                    tabFontSize='font-size-smaller'
                                    tabs={[
                                        { text: 'Info', content: () => (
                                            <div className='flexed p-4 row-based bg-light-gray container'>
                                                <AgTechFieldList
                                                    fields={[
                                                        { name: 'Ranch Name', value: contact.ranchName ? contact.ranchName : 'N/A' },
                                                        { name: 'Email Address', value: contact.emailAddress ? contact.emailAddress : 'N/A' },
                                                        { name: 'Phone Number', value: contact.phoneNumber ? contact.phoneNumber : 'N/A' },
                                                    ]}
                                                />
                                                <AgTechFieldList
                                                    fields={[
                                                        { name: 'Address', value: contact.address ?? 'N/A' },
                                                    ]}
                                                />
                                                <AgTechFieldList
                                                    fields={[
                                                        { name: 'City', value: contact.city ?? 'N/A' },
                                                        { name: 'State', value: contact.stateAbbreviation ?? 'N/A' },
                                                        { name: 'Zip', value: contact.zip ?? 'N/A' },
                                                    ]}
                                                />
                                            </div>
                                        )},
                                        { text: 'Notes', displayText: `Notes (${Object.keys(contactDetails.notes).length})`, content: () => (
                                            <ContactPopUpNotesTab contactDetails={contactDetails} />
                                        )},
                                        { text: 'Credits', displayText: `Credits (${Object.keys(contactDetails.credits).length})`, content: () => (
                                            <SaleContactDetailPopUpCreditsTab contactDetails={contactDetails} />
                                        )},
                                    ]}
                                />
                            </div>
                            <div className='column-based px-4 top-bordered container' style={{ height: 40 }}>
                                <SaleContactDetailDialog.Button
                                    contactId={props.contactId}
                                    classes='ml-auto button-link p-0'
                                />
                            </div>
                        </div>
                    );
                }}
            </SaleContactDetailsProvider>
        </div>
    )
}

export default SaleContactDetailPopUp